import en from "./en";
import de from "./de";
import by from "./by";

const lang = {
    en, 
    de,
    by
}
export default lang;